module.exports = __webpack_public_path__ + "static/media/vf_wknit_core.ebb7d92d.svg";